module.exports = __webpack_public_path__ + "media/stylesheets/images/lectures/review_sample_image1-67cbf31fa269336d1b4a676370d1bc72.png";